export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyC3oI3BBDFDFhV6tFlx3M0U7voj6Rmakw8",
    authDomain: "moments-8ba80.firebaseapp.com",
    databaseURL: "https://moments-8ba80.firebaseio.com",
    projectId: "moments-8ba80",
    storageBucket: "moments-8ba80.appspot.com",
    messagingSenderId: "457007054631"
}



// WEBPACK FOOTER //
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/app.env.config.ts